export default "/images/Bookings.jpg?b888f48f447a9985b927e0e59bfd5a29";